var render = function render(){var _vm=this,_c=_vm._self._c;return _c('input',_vm._b({directives:[{name:"model",rawName:"v-model",value:(_vm.model),expression:"model"}],staticClass:"number-input",attrs:{"type":"number"},domProps:{"value":(_vm.model)},on:{"input":function($event){if($event.target.composing)return;_vm.model=$event.target.value}}},'input',{ min: _vm.min, max: _vm.max, step: _vm.step },false))
}
var staticRenderFns = []

export { render, staticRenderFns }